import { Box }            from '@chakra-ui/react';
import CandidaciesListRow from './CandidaciesListRow';
import CandidacyModel     from '@/models/services/rh/CandidacyModel';
import { Link }           from 'react-router-dom';
import List               from '@/components/list/List';
import WorkIcon           from '@/assets/icons/WorkIcon';
import config             from '@/config';
import usePagedCollection from '@widesk-core/hooks/usePagedCollection';
import { useTranslation } from 'react-i18next';

const CandidaciesListBox = () => {
	const { t } = useTranslation();

	const candidacyCollection = usePagedCollection(CandidacyModel);

	return (
		<List
			collection={candidacyCollection}
			renderRow={(model) => <CandidaciesListRow candidacy={model} />}
			options={{
				clickable: true,
				hideErrorMessage: true,
				emptyAlert: {
					title: (
						<Box 
							display="flex" 
							flexDirection="column"
							gap="10px"
							width="100%"
						>
							<Box>{t('pages.candidacies.list.empty.alert.text')} </Box>

							<Link to={config.rh_url} target="_blank" style={{ fontWeight: 'bold', textDecoration: 'underline', width: 'fit-content' }}>
								{t('pages.candidacies.list.empty.alert.link')}
							</Link>
						</Box>
					),
				},
				emptyMessages: {
					title: t('pages.candidacies.list.empty.title'),
					description: t('pages.candidacies.list.empty.description'),
					icon: <WorkIcon size="xl" />,
				},
				itemsMargin: '10px 0px 10px 0px',
				itemsPadding: '10px',
				padding: '0px 10px 0px 10px',
				withSeparators: true,
			}}
		/>
	)
}

export default CandidaciesListBox